import React from 'react'
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

// import StartButton from './StartButton'

const styles = theme => ({
  time:{
    fontSize:30,
    textAlign: 'center',
    marginTop:5,
    marginBottom:12,
  }
})

class Timer extends React.Component {
    constructor(props){
      super()
      this.displayTime = this.displayTime.bind(this)
    }


    displayTime() {
      //calc sec from ms
      const { classes } = this.props;
      let ms = this.props.time % 1000
      let minInSec = (this.props.time -ms) / 1000
      //calt leftTime
      let leftTimeInSec = this.props.duration - minInSec
      let sec = leftTimeInSec % 60
      let min = (leftTimeInSec-sec) / 60
      let zeroPaddedSec = String(sec).padStart(2, '0')
      return(<h3 className={classes.time}>残り時間 {min}:{zeroPaddedSec}</h3>)
    }

  render() {

    return(
      <div>
        <this.displayTime />
      </div>
    )
  }
}

Timer.propTypes={
  clasees:PropTypes.object.isRequired,
  time:PropTypes.number.isRequired,
  duration:PropTypes.number.isRequired,

}

export default withStyles(styles, { withTheme: true})(Timer);



// WEBPACK FOOTER //
// ./src/components/quiz/Timer.js